<c-navbar
  fixed="top"
  expand="lg"
  class="custom-navbar"
  colorScheme="light"
>
  <c-container class="nav-shell px-4 px-lg-5">
    <img
      src="assets/imalogo.png"
      class="sidebar-brand-full mx-1"
      height="32"
      width="32"
      alt="IMA One"
    />
    <a cNavbarBrand routerLink="/" class="text-custom-light fw-bold">IMA One</a>

    <button
      cButton
      class="navbar-toggler custom-toggler"
      type="button"
      [cNavbarToggler]="collapseRef"
    >
      <svg cIcon name="cil-menu" class="text-custom-mint"></svg>
    </button>

    <c-collapse #collapseRef="cCollapse" navbar cCollapse>
      <c-navbar-nav class="ms-auto align-items-start align-items-lg-center gap-2 gap-lg-4">

        <c-dropdown variant="nav-item" [dark]="false">
          <a cDropdownToggle cNavLink class="nav-link-custom cursor-pointer">{{ 'marketing.nav.explore' | translate }}</a>
          <ul cDropdownMenu class="custom-dropdown-menu nav-flyout-menu border-0 mt-2">
            <li><a cDropdownItem routerLink="/discover/features">{{ 'marketing.nav.features' | translate }}</a></li>
            <li><a cDropdownItem routerLink="/discover/solutions">{{ 'marketing.nav.solutions' | translate }}</a></li>
            <li><a cDropdownItem routerLink="/discover/cases">{{ 'marketing.nav.cases' | translate }}</a></li>
            <li><hr cDropdownDivider class="border-secondary opacity-25"></li>
            <li><a cDropdownItem routerLink="/about">{{ 'marketing.nav.about' | translate }}</a></li>
          </ul>
        </c-dropdown>

        <c-dropdown variant="nav-item" [dark]="false">
          <a cDropdownToggle cNavLink class="nav-link-custom cursor-pointer">{{ 'marketing.nav.services' | translate }}</a>
          <ul cDropdownMenu class="custom-dropdown-menu nav-flyout-menu border-0 mt-2">
            <li><a cDropdownItem routerLink="/service/analysis">{{ 'marketing.nav.serviceAnalysis' | translate }}</a></li>
            <li><a cDropdownItem routerLink="/service/audit">{{ 'marketing.nav.serviceAudit' | translate }}</a></li>
            <li><a cDropdownItem routerLink="/service/maintenance">{{ 'marketing.nav.serviceMaintenance' | translate }}</a></li>
            <li><a cDropdownItem routerLink="/service/consulting">{{ 'marketing.nav.serviceConsulting' | translate }}</a></li>
          </ul>
        </c-dropdown>

        <a cNavLink routerLink="/pricing" class="nav-link-custom">{{ 'marketing.nav.pricing' | translate }}</a>
        <a cNavLink routerLink="/contact" class="nav-link-custom">{{ 'marketing.nav.contact' | translate }}</a>
        <a cNavLink routerLink="/help" class="nav-link-custom">{{ 'marketing.nav.help' | translate }}</a>

        <ng-container *ngIf="!isLoggedIn">
          <a cNavLink routerLink="/sign-in" class="nav-link-custom">{{ 'marketing.nav.signIn' | translate }}</a>
          <a cNavLink routerLink="/register" class="nav-link-custom">{{ 'marketing.nav.register' | translate }}</a>
        </ng-container>

        <ng-container *ngIf="isLoggedIn">
          <div class="home-header-workspace-wrap">
            <button
              type="button"
              class="btn btn-try home-header-workspace-btn"
              (click)="goToWorkspace()"
            >
              {{ 'marketing.nav.workspace' | translate }}
            </button>
          </div>

          <c-dropdown
            variant="nav-item"
            [dark]="false"
            [(visible)]="userMenuOpen"
            class="home-header-user-dropdown"
          >
            <button
              type="button"
              cDropdownToggle
              class="home-header-user-toggle border-0 bg-transparent d-flex align-items-center gap-2"
              [attr.aria-label]="'header.open_user_menu' | translate"
              aria-haspopup="true"
              [attr.aria-expanded]="userMenuOpen"
            >
              <img
                [src]="profilePicture || defaultAvatarUrl"
                class="home-header-user-toggle__avatar"
                width="36"
                height="36"
                alt=""
                (error)="onAvatarImageError()"
              />
              <span class="home-header-user-toggle__name d-none d-xl-inline">{{ displayName }}</span>
            </button>
            <ul cDropdownMenu class="custom-dropdown-menu nav-flyout-menu border-0 mt-2 home-header-user-menu">
              <li class="home-header-user-menu__hero px-3 py-3">
                <img
                  [src]="profilePicture || defaultAvatarUrl"
                  class="home-header-user-menu__avatar rounded-circle"
                  width="56"
                  height="56"
                  alt=""
                  (error)="onAvatarImageError()"
                />
                <div class="home-header-user-menu__name fw-semibold">{{ displayName }}</div>
                <div class="home-header-user-menu__email text-muted small">{{ user.email }}</div>
              </li>
              <li><hr cDropdownDivider class="border-secondary opacity-25"></li>
              <li>
                <a cDropdownItem routerLink="/help" class="dropdown-item" (click)="userMenuOpen = false">
                  {{ 'header.user_guide' | translate }}
                </a>
              </li>
              <li>
                <a cDropdownItem routerLink="/settings" class="dropdown-item" (click)="userMenuOpen = false">
                  {{ 'header.system_settings' | translate }}
                </a>
              </li>
              <li><hr cDropdownDivider class="border-secondary opacity-25"></li>
              <li>
                <button cDropdownItem type="button" class="dropdown-item text-danger" (click)="onLogout()">
                  {{ 'common.logout' | translate }}
                </button>
              </li>
            </ul>
          </c-dropdown>
        </ng-container>

      </c-navbar-nav>
    </c-collapse>

  </c-container>
</c-navbar>
<router-outlet />
<app-home-footer />
